import { ContentSwitcherValue } from '../../types';

export const getRelatedParams = (
  values: ContentSwitcherValue[],
  paramKey: string,
  paramValue: string,
): ContentSwitcherValue[] => {
  // find the value for the current param
  const value = values.find(({ param }) => paramKey === param);
  // get the item for the current param value
  const item = value?.items.find(({ id }) => id === paramValue);

  if (item?.children) {
    // go through the children object and filter the items in other param
    return Object.entries(item.children).reduce(
      (arr: ContentSwitcherValue[], [key, itemsToFilter]) => {
        const index = values.findIndex(({ param }) => param === key);
        if (index !== -1) {
          arr.push({
            ...values[index],
            items: values[index].items.filter(({ id }) =>
              itemsToFilter.includes(id),
            ),
          });

          return arr;
        }
        return arr;
      },
      [],
    );
  }

  return [];
};
